export default __webpack_public_path__ + "static/DayDreams-2adb798e2f513ea62d9757ea008c67ce.pdf";